import warn from "../constants/toast";

const handleApiError = (error: any) => {
  if (error?.response?.status >= 400 && error.response.status < 500) {
    warn.wargingError(
      error?.response?.data?.notifications[
        error?.response?.data?.notifications.length - 1
      ].message
    );
  } else {
    warn.wargingError("⚠ Erro na conexão com o servidor!");
  }
};

export default handleApiError;
